import { Component, Inject, OnInit, PLATFORM_ID, Renderer2  } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SpinnerService } from './core/services/spinner.service';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from './core/services/account.service';
import { isPlatformBrowser } from '@angular/common';
import { NgxSpinnerModule } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgxSpinnerModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Refeezy-Frontend';
  loading$ = this.spinnerService.loading$;
  private isBrowser: boolean;
  constructor(private spinnerService: SpinnerService,
    private translate: TranslateService,
    private renderer: Renderer2,
    private accountService:AccountService,
    @Inject(PLATFORM_ID) private platformId: Object) {
      this.isBrowser = isPlatformBrowser(this.platformId);
      this.translate.addLangs(['en-US', 'ar-SA']);
      const savedLang = localStorage.getItem('selectedLang') || 'ar-SA';
      this.translate.setDefaultLang(savedLang);
      this.translate.use(savedLang);
      this.updateDirection(savedLang);

  }

  updateDirection(lang: string) {
    const dir = lang === 'ar-SA' ? 'rtl' : 'ltr';
    this.renderer.setAttribute(document.documentElement, 'dir', dir);
    this.renderer.setAttribute(document.documentElement, 'lang', lang);
  }
  ngOnInit(): void {
    if (this.isBrowser) {
      this.serCurrentUser();
      }
  }


  serCurrentUser(){
    var loginVerifyResponse=localStorage.getItem("client");
     if( !loginVerifyResponse)return

     this.accountService.setCurrentUser(JSON.parse(loginVerifyResponse));
   }
}
